import Theme from 'Theme';
import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';

export const dropDownWidth = 14 * Theme.BU;

export const dropDownIconSize = 20;

const baseStyles = {
    searchInput: {
        flex: 16, // take all the empty space!
        marginLeft: 15,
        marginRight: 0
    },
    searchInputManageFavorites: {
        marginVertical: 0
    },
    tabletTopBar: {
        margin: Theme.primaryMargin,
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'flex-start'
    },
    categoryDropdown: {
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        borderWidth: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.95)'
    },
    pickerButton: {
        flex: 0,
        width: dropDownWidth
    },
    pickerButtonOpen: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderWidth: 0
    },
    pickerButtonText: {
        alignSelf: 'flex-start'
    },
    pickerButtonTextOpen: {
        color: Theme.secondaryTextColor
    },
    pickerItemButton: {
        backgroundColor: 'transparent',
        alignSelf: 'stretch',
        borderWidth: 0,
        width: dropDownWidth
    },
    pickerItemText: {
        color: Theme.secondaryTextColor,
        alignSelf: 'flex-start'
    },
    searchMarginContainer: {
        marginLeft: Theme.primaryMargin,
        flex: 1
    }
};

if (Device.isWeb) {
    baseStyles.pickerItemButton = {
        ...baseStyles.pickerItemButton,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        width: dropDownWidth,
        borderWidth: 0
    };

    baseStyles.tabletTopBar = {
        ...baseStyles.tabletTopBar,
        paddingTop: 40,
        alignItems: 'strech'
    };
}

export default StyleSheet.create(baseStyles);
